import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Fragment, useMemo } from 'react';
import { Box, IconButton, Row } from 'seagull';
import { CloseCross } from 'seagull/icons/essentials';
import { getTestIds } from 'seagull/utils/TestIds';
import { ChipConnector } from '~/components/AiSearchChips/ChipConnector/ChipConnector';
import { buildAgreementPredicateChipUnits, buildPredicateCallbacks } from '../AgreementPredicateChips.utils';
import styles from './AgreementOrGroup.module.scss';
import { armChipTestIds, armReactKeys, rebuildOrArms } from './AgreementOrGroup.utils';
export const GetAgreementOrGroupTID = (parentTestId)=>getTestIds(parentTestId);
export const AgreementOrGroup = (param)=>{
    let { testId, arms, texts, onChange } = param;
    const { AgreementOrGroupTestIds } = useMemo(()=>GetAgreementOrGroupTID(testId), [
        testId
    ]);
    if (arms.length === 0) return null;
    const reactKeys = armReactKeys(arms);
    const armEntries = arms.map((arm, index)=>({
            index,
            units: buildAgreementPredicateChipUnits({
                predicate: arm,
                testIds: armChipTestIds(AgreementOrGroupTestIds.Arm, index),
                callbacks: buildPredicateCallbacks(arm, (next)=>onChange(rebuildOrArms(arms, index, next))),
                texts
            })
        })).filter((entry)=>entry.units.length > 0);
    return /*#__PURE__*/ _jsxs(Box, {
        testId: AgreementOrGroupTestIds.Root(),
        inline: true,
        className: styles.group,
        children: [
            armEntries.map((entry, position)=>/*#__PURE__*/ _jsxs(Fragment, {
                    children: [
                        position > 0 && /*#__PURE__*/ _jsx(ChipConnector, {
                            testId: AgreementOrGroupTestIds.Connector(position),
                            tone: "or"
                        }),
                        /*#__PURE__*/ _jsx(Box, {
                            testId: AgreementOrGroupTestIds.Arm.Root(entry.index),
                            inline: true,
                            children: /*#__PURE__*/ _jsx(Row, {
                                alignItems: "center",
                                gap: 8,
                                wrap: true,
                                children: entry.units.map((unit)=>/*#__PURE__*/ _jsx(Fragment, {
                                        children: unit.node
                                    }, unit.key))
                            })
                        })
                    ]
                }, reactKeys[entry.index])),
            /*#__PURE__*/ _jsx(IconButton, {
                testId: AgreementOrGroupTestIds.Remove(),
                bi: {
                    name: 'agreements_ai_chip_remove_or_group'
                },
                onClick: ()=>onChange(undefined),
                size: "small",
                children: /*#__PURE__*/ _jsx(CloseCross, {
                    size: 10
                })
            })
        ]
    });
};
